function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const colors = {
  error: "var(--error)",
  warning: "var(--warning)",
  information: "var(--info)",
  info: "var(--info)",
  success: "var(--success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-on-color)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const ContactUsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Contact-us",
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 54
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Contact-us"
}, " Contact us"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-fill",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.3,
  d: "M52.99 24.182a9.138 9.138 0 0 0-8.566-9.101C43.332 6.476 36.014.025 27.34.02h-.852C17.83.035 10.526 6.475 9.428 15.065a9.129 9.129 0 0 0 .24 18.255.701.701 0 0 0 .493-.208.696.696 0 0 0 .535-.67v-15.23c0-.273.027-.536.043-.809a12.543 12.543 0 0 0 10.61-7.066 17.763 17.763 0 0 0 20.68 2.088 15.691 15.691 0 0 1 1.11 5.787v15.23a15.873 15.873 0 0 1-11.125 15.081 4.588 4.588 0 1 0-.118 1.505h.102a17.292 17.292 0 0 0 12.517-15.745 9.138 9.138 0 0 0 8.474-9.101zm-51.036 0a7.725 7.725 0 0 1 7.361-7.704c0 .246-.037.487-.037.734v14.674a7.725 7.725 0 0 1-7.335-7.704h.011zm31.227-11.778a16.334 16.334 0 0 1-11.563-4.76.707.707 0 0 0-1.151.247 11.146 11.146 0 0 1-9.605 7.088A15.814 15.814 0 0 1 26.49 1.408h.852a15.804 15.804 0 0 1 14.106 8.726 16.36 16.36 0 0 1-8.266 2.27zM27.442 51.1a3.212 3.212 0 1 1 0-6.424 3.212 3.212 0 0 1 0 6.424zm17.132-19.224V17.212c0-.241 0-.477-.038-.718a7.72 7.72 0 0 1 .016 15.376l.022.005z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.504,
  cy: 21.639,
  r: 2.05,
  className: "primary",
  fill: "#434957"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.01,
  cy: 21.639,
  r: 2.05,
  className: "primary",
  fill: "#434957"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 0.8,
  d: "M35.569 30.628a.707.707 0 0 0-1.301-.536 7.72 7.72 0 0 1-14.224 0 .707.707 0 0 0-1.301.536 9.133 9.133 0 0 0 16.826 0z"
})));
export const FaqIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-FAQ",
  xmlns: "http://www.w3.org/2000/svg",
  width: 61,
  height: 49,
  viewBox: "0 0 61 49"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-FAQ"
}, " FAQ"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.41 27.018c4.549-2.479 7.551-6.73 7.551-11.561 0-7.65-7.523-13.851-16.804-13.851-8.478 0-15.486 5.176-16.635 11.903 6.896 2.214 11.807 7.817 11.807 14.366 0 .282-.011.563-.03.843 1.539.382 3.169.59 4.858.59 1.609 0 3.163-.19 4.636-.538 0 0 4.056 4.167 9.078 4.167 0 0-3.832-1.974-4.461-5.919z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.3,
  d: "M56.585 31.582c-.023-.012-2.504-1.344-3.398-3.83 4.606-2.899 7.32-7.42 7.32-12.295 0-8.48-8.231-15.38-18.349-15.38C33 .077 25.388 5.73 24.026 13.09a21.59 21.59 0 0 0-5.046-.596c-10.118 0-18.349 6.9-18.349 15.38 0 4.874 2.714 9.397 7.32 12.295-.894 2.486-3.376 3.819-3.404 3.833a1.527 1.527 0 0 0-.776 1.722 1.54 1.54 0 0 0 1.496 1.16c4.433 0 8.104-2.772 9.544-4.033 1.37.267 2.768.402 4.17.402 9.158 0 16.77-5.653 18.131-13.015a21.59 21.59 0 0 0 5.047.597c1.401 0 2.8-.135 4.17-.402 1.44 1.26 5.11 4.032 9.543 4.032a1.54 1.54 0 0 0 1.5-1.165 1.524 1.524 0 0 0-.787-1.719zM18.98 41.726c-1.608 0-3.162-.19-4.635-.538 0 0-4.057 4.168-9.078 4.168 0 0 3.832-1.975 4.46-5.92-4.548-2.478-7.55-6.73-7.55-11.561 0-7.65 7.523-13.851 16.803-13.851 9.28 0 16.804 6.201 16.804 13.85 0 7.651-7.524 13.852-16.804 13.852zM46.793 28.77a20.15 20.15 0 0 1-4.636.538c-1.689 0-3.319-.208-4.857-.59.018-.28.029-.56.029-.843 0-6.55-4.911-12.152-11.807-14.366 1.15-6.727 8.157-11.903 16.635-11.903 9.28 0 16.804 6.201 16.804 13.85 0 4.832-3.003 9.083-7.551 11.562.629 3.945 4.46 5.92 4.46 5.92-5.021 0-9.077-4.168-9.077-4.168z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.305,
  cy: 16.098,
  className: "secondary-stroke secondary-fill",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 1.076,
  rx: 1.379,
  ry: 1.364
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.242,
  cy: 16.098,
  className: "secondary-stroke secondary-fill",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 1.076,
  rx: 1.379,
  ry: 1.364
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48.178,
  cy: 16.098,
  className: "secondary-stroke secondary-fill",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 1.076,
  rx: 1.379,
  ry: 1.364
})));
export const AddTwoColorIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1637.000000, -459.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(395.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add_ic",
  transform: "translate(1242.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "primary-fill",
  cx: 11,
  cy: 11,
  r: 11
}), /*#__PURE__*/React.createElement("polygon", {
  className: "secondary-stroke secondary-fill",
  fillRule: "nonzero",
  points: "10.6666667 7 10.6666667 10.6666667 7 10.6666667 7 11.3333333 10.6666667 11.3333333 10.6666667 15 11.3333333 15 11.3333333 11.3333333 15 11.3333333 15 10.6666667 11.3333333 10.6666667 11.3333333 7"
}))))));
export const ApiTwoColorIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 38,
  viewBox: "0 0 70 38"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(14 3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M36.704.094H5.296C2.51.094.274 2.408.274 5.29V28.71c0 2.88 2.237 5.195 5.022 5.195h31.408c2.785 0 5.022-2.314 5.022-5.195V5.29c0-2.833-2.237-5.195-5.022-5.195zM39.9 28.711c0 1.842-1.415 3.306-3.196 3.306H5.296c-1.78 0-3.196-1.464-3.196-3.306V9.256h37.8V28.71zm0-21.344H2.1V5.289c0-1.842 1.415-3.306 3.196-3.306h31.408c1.78 0 3.196 1.464 3.196 3.306v2.078z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.885,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.587,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.335,
  cy: 4.722,
  className: "primary-fill",
  fill: "#434957",
  rx: 1.552,
  ry: 1.606
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M27.026 27.2c.183.189.411.283.64.283a.887.887 0 0 0 .638-.283l5.844-6.044a.935.935 0 0 0 0-1.323l-5.844-6.091a.863.863 0 0 0-1.278 0 .935.935 0 0 0 0 1.322l5.204 5.383-5.204 5.384a.993.993 0 0 0 0 1.369zM13.696 27.2c.182.189.41.283.639.283a.887.887 0 0 0 .639-.283.935.935 0 0 0 0-1.322l-5.204-5.43 5.204-5.337a.935.935 0 0 0 0-1.322.863.863 0 0 0-1.278 0l-5.844 5.997a.935.935 0 0 0 0 1.322l5.844 6.092z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M17.44 27.342c.136.094.273.094.41.094.32 0 .64-.189.822-.52l6.3-12.088c.228-.472.091-1.04-.365-1.275-.457-.236-1.005-.095-1.233.378l-6.3 12.136a.908.908 0 0 0 .365 1.275z"
})));
export const AssessmentsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Assessments",
  xmlns: "http://www.w3.org/2000/svg",
  width: 69,
  height: 32,
  viewBox: "0 0 69 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Assessments"
}, " Assessments"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M37.442 4.305c-1.122-.605-2.679-.662-4.245-.662-4.005 0-7.696 1.794-10.052 4.786-6.989-4.637-14.763.299-15.077 6.58C3.984 15.682 1 19.047 1 23.085c0 3.597 2.443 6.823 6.172 7.878.147.042 27.91-.034 28.061 0 .42.097-.428-1.429-.81-1.55-.15-.048-26.343.145-27.25-.245-2.623-1.128-4.716-3.485-4.602-6.083.314-6.73 7.067-6.805 7.067-6.805-.55-7.104 8.482-11.067 13.822-5.608 0 0 2.984-5.534 9.737-5.534.954 0 1.922 0 2.7.307.784.31 2.01-.888 1.545-1.14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.785,
  d: "M42.738 10h4.393v21h-4.393z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  stroke: "#434957",
  strokeWidth: 1.7,
  d: "M52.843 1h4.393v30h-4.393V1zm10.105 14.786h4.393V31h-4.393V15.786z"
})));
export const AutomationIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Automation",
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 44
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Automation"
}, " Automation"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M16.2839 16.8212c-3.6855 0-6.6836-2.998-6.6836-6.6836 0-3.7091 2.998-6.7075 6.6836-6.7075h3.4036V2.3125C19.6875 1.5877 20.2752 1 21 1s1.3125.5877 1.3125 1.3125v1.118h3.4036c3.6855 0 6.6836 2.9983 6.6836 6.6835 0 3.7091-2.998 6.7072-6.6836 6.7072H16.284zm0-10.7661c-2.2379 0-4.0586 1.8208-4.0586 4.0586 0 2.2617 1.8207 4.0822 4.0586 4.0822h9.4322c2.2379 0 4.0586-1.8205 4.0586-4.0583 0-2.2617-1.8207-4.0825-4.0586-4.0825H16.284zm.2605 5.9473c-1.0214 0-1.8493-.8402-1.8493-1.8766s.828-1.8765 1.8493-1.8765 1.8493.8401 1.8493 1.8765-.828 1.8766-1.8493 1.8766zm8.9112 0c-1.0213 0-1.8493-.8402-1.8493-1.8766s.828-1.8765 1.8493-1.8765c1.0214 0 1.8493.8401 1.8493 1.8765s-.828 1.8766-1.8493 1.8766zm14.9756-.6018c.7249 0 1.3125.5876 1.3125 1.3128v1.3125c0 1.8073-1.1763 3.3423-2.8025 3.8873-.1253 3.7711-2.912 6.8723-6.5415 7.4858v5.6586c0 2.533-2.061 4.5937-4.5937 4.5937h-2.8987v3.4417C24.9073 41.2472 23.1545 43 21 43c-2.1545 0-3.9073-1.7528-3.9073-3.907v-3.4417H14.194c-2.5328 0-4.5937-2.0606-4.5937-4.5937v-.2901c0-.7248.5877-1.3125 1.3125-1.3125s1.3125.5877 1.3125 1.3125v.29c0 1.0858.883 1.9688 1.9687 1.9688h13.612c1.0857 0 1.9687-.883 1.9687-1.9687V24.205c0-.7248.5877-1.3125 1.3125-1.3125 2.8052 0 5.0961-2.2165 5.2297-4.9891-1.6124-.553-2.7763-2.0804-2.7763-3.8778V12.713c0-.7248.5877-1.3125 1.3125-1.3125s1.3125.5877 1.3125 1.3125v1.3125c0 .814.6628 1.4765 1.4766 1.4765.8137 0 1.4765-.6624 1.4765-1.4765V12.713c0-.7248.5877-1.3125 1.3125-1.3125zM22.2823 39.093v-3.4417h-2.5646v3.4417c0 .7068.5755 1.282 1.2823 1.282s1.2823-.5752 1.2823-1.282zm-10.057-14.888c0 .7248-.5877 1.3125-1.3125 1.3125h-6.555c-.7248 0-1.3125-.5877-1.3125-1.3125v-6.297c-1.619-.549-2.789-2.08-2.789-3.8824V12.713c0-.7248.5876-1.3125 1.3125-1.3125.7248 0 1.3125.5877 1.3125 1.3125v1.3125c0 .814.6628 1.4765 1.4765 1.4765.8138 0 1.4766-.6624 1.4766-1.4765V12.713c0-.7248.5877-1.3125 1.3125-1.3125s1.3125.5877 1.3125 1.3125v1.3125c0 1.8024-1.1701 3.3334-2.789 3.8824v4.9845h3.9299V22.84c0-2.5331 2.061-4.5938 4.5937-4.5938h16.8932c.7248 0 1.3125.5877 1.3125 1.3125 0 .7249-.5877 1.3125-1.3125 1.3125H14.194c-1.0857 0-1.9687.883-1.9687 1.9688v1.365z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M15.5384 22.8925c-.7249 0-1.3125.5877-1.3125 1.3125v5.4879c0 .7248.5876 1.3125 1.3125 1.3125H26.462c.7248 0 1.3125-.5877 1.3125-1.3125V24.205c0-.7248-.5877-1.3125-1.3125-1.3125H15.5384zm9.611 5.4876H16.851v-2.863h8.2986v2.863z"
})));
export const CalculatorIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Calculator",
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Calculator"
}, " Calculator"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M24.777.094H3.223C1.59.094.26 1.437.26 3.087v21.776c0 1.65 1.329 2.993 2.962 2.993h21.554c1.633 0 2.962-1.343 2.962-2.993V3.087c0-1.65-1.329-2.993-2.962-2.993zm1.417 2.993v10.03H14.772V1.655h10.005c.782 0 1.417.642 1.417 1.432zM3.223 1.655h10.004v11.462H1.806V3.087c0-.79.636-1.432 1.417-1.432zM1.806 24.863V14.678h11.421v11.617H3.223a1.426 1.426 0 0 1-1.417-1.432zm22.971 1.432H14.772V14.678h11.422v10.185c0 .79-.635 1.432-1.417 1.432z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M4.718 8.435h1.98v2c0 .43.345.78.772.78.426 0 .772-.35.772-.78v-2h1.98c.426 0 .772-.35.772-.78a.777.777 0 0 0-.773-.781H8.242v-2a.777.777 0 0 0-.772-.78.776.776 0 0 0-.773.78v2H4.718a.776.776 0 0 0-.772.78c0 .432.345.78.772.78zM18.042 8.435h5.503c.427 0 .772-.35.772-.78a.776.776 0 0 0-.772-.781h-5.503a.776.776 0 0 0-.773.78c0 .432.346.78.773.78zM8.562 20.77l1.4-1.415a.786.786 0 0 0 0-1.103.767.767 0 0 0-1.093 0l-1.4 1.414-1.399-1.414a.767.767 0 0 0-1.092 0 .786.786 0 0 0 0 1.103l1.4 1.414-1.4 1.414a.786.786 0 0 0 0 1.103.767.767 0 0 0 1.092 0l1.4-1.413 1.4 1.413a.767.767 0 0 0 1.092 0 .786.786 0 0 0 0-1.103l-1.4-1.414z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M23.545 18.533h-5.503a.776.776 0 0 0-.773.78c0 .431.346.78.773.78h5.503c.427 0 .772-.349.772-.78 0-.43-.345-.78-.772-.78zM23.545 21.444h-5.503a.776.776 0 0 0-.773.78c0 .431.346.781.773.781h5.503c.427 0 .772-.35.772-.78 0-.431-.345-.78-.772-.78z"
})));
export const CaseStudyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Case-study",
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 34,
  viewBox: "0 0 31 34"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Case-study"
}, " Case study"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  stroke: "#434957",
  strokeWidth: 1.8,
  d: "M15.195 5.9L5.9 14.703V32A1.1 1.1 0 0 0 7 33.1h22a1.1 1.1 0 0 0 1.1-1.1V7A1.1 1.1 0 0 0 29 5.9H15.195z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M8.04 0c7.393 0 10.878 8.99 5.293 13.76l3.52 5.033c.584.835-.718 1.703-1.303.868l-3.498-5.006C6.736 17.645 0 13.905 0 7.85 0 3.517 3.599 0 8.04 0zm4.573 3.39C8.553-.574 1.576 2.245 1.576 7.85c0 5.605 6.975 8.424 11.037 4.462a6.202 6.202 0 0 0 0-8.923z"
})));
export const CheckCircleTwoColorIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary primary-fill",
  fill: "#3D84FF",
  d: "M33.456 14.481a.985.985 0 0 0-.7-.302c-.25 0-.5.1-.7.302L21.797 24.8l-3.803-3.825c-.4-.403-1.051-.403-1.401 0l-4.353 4.278a.977.977 0 0 0 0 1.409l8.806 8.858c.2.201.45.302.7.302.25 0 .501-.1.701-.302l15.311-15.3a.977.977 0 0 0 0-1.41l-4.303-4.328zM21.798 33.405l-7.406-7.449 2.902-2.919 3.803 3.825c.2.202.45.302.7.302.25 0 .501-.1.701-.302l10.258-10.317 2.902 2.919-13.86 13.941z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "secondary secondary-stroke",
  cx: 25,
  cy: 25,
  r: 25,
  stroke: "#434957",
  strokeWidth: 2
})));
export const ClientManageIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Manage-clients",
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 46,
  viewBox: "0 0 64 46"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Manage-clients"
}, "Manage clients"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  className: "primary-stroke",
  stroke: "#434957",
  strokeWidth: 1.7,
  d: "M36.533 6.719c.11.072.257.143.324.282.131.271-.258 1.123-.36 1.343-.197.425-.437.57-.635.788-.253 1.18-.66 2.205-1.295 3.005.074.388-.032.819.074 1.108.122.328.74.581 1.12.69 2.626.75 6.453.484 6.349 4.182-.014.497.033.343-.199.73-.112.186-.676.436-.97.591-2.386 1.25-5.365 1.896-8.939 1.896-3.545 0-6.486-.628-8.914-1.896-.307-.16-.823-.36-.97-.567-.24-.337-.201-.209-.225-.73-.14-3.068 2.445-3.231 4.88-3.838.865-.215 2.339-.473 2.59-1.083.069-.17.11-.55.05-.838-.037-.17-.3-.47-.449-.715a6.722 6.722 0 0 1-.722-1.576c-.1-.326-.108-.678-.224-.911a1.898 1.898 0 0 0-.312-.443c-.13-.145-.29-.307-.374-.492-.122-.272-.487-.958-.36-1.22.061-.126.186-.29.424-.283-.523-3.17 1.331-5.206 4.084-5.393 3.25-.222 5.77 2.028 5.053 5.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  d: "M32 33.732z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M38.031 35.348l-5.409-2.4v-5.6a.964.964 0 0 0-1.928 0v5.6l-5.409 2.4a.89.89 0 0 0-.438 1.206.962.962 0 0 0 1.253.456l5.558-2.465 5.557 2.464a.963.963 0 0 0 1.255-.455.89.89 0 0 0-.439-1.206z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  className: "primary-stroke",
  stroke: "#434957",
  strokeWidth: 1.7,
  d: "M16.316 30.05c.109.073.256.144.324.283.132.271-.259 1.123-.36 1.343-.198.426-.438.57-.636.788-.253 1.18-.66 2.205-1.295 3.006.075.389-.032.82.075 1.109.121.326.738.58 1.12.688 2.627.75 6.453.485 6.349 4.182-.015.498.033.344-.2.731-.111.185-.675.435-.97.591-2.385 1.249-5.364 1.896-8.938 1.896-3.546 0-6.487-.628-8.914-1.896-.308-.161-.824-.36-.971-.567-.239-.338-.2-.21-.224-.73-.14-3.069 2.445-3.232 4.88-3.839.864-.215 2.338-.473 2.589-1.083.07-.17.111-.55.05-.838-.036-.17-.3-.47-.448-.715a6.747 6.747 0 0 1-.722-1.576c-.1-.326-.108-.678-.225-.91a1.896 1.896 0 0 0-.312-.443c-.129-.145-.289-.307-.373-.492-.123-.272-.488-.959-.36-1.22.06-.125.186-.29.423-.283-.523-3.17 1.332-5.206 4.084-5.393 3.251-.221 5.77 2.027 5.054 5.369zM56.75 30.05c.11.073.258.144.324.283.132.271-.258 1.123-.36 1.343-.197.426-.437.57-.634.788-.253 1.18-.66 2.205-1.296 3.006.074.389-.031.82.074 1.109.122.326.74.58 1.12.688 2.627.75 6.454.485 6.35 4.182-.015.498.032.344-.2.731-.111.185-.675.435-.97.591-2.385 1.249-5.364 1.896-8.939 1.896-3.545 0-6.487-.628-8.914-1.896-.307-.161-.823-.36-.97-.567-.24-.338-.2-.21-.224-.73-.14-3.069 2.445-3.232 4.88-3.839.864-.215 2.339-.473 2.589-1.083.07-.17.11-.55.05-.838-.036-.17-.3-.47-.448-.715a6.748 6.748 0 0 1-.722-1.576c-.099-.326-.107-.678-.224-.91a1.841 1.841 0 0 0-.313-.443c-.13-.145-.289-.307-.373-.492-.123-.272-.489-.959-.36-1.22.06-.125.185-.29.423-.283-.523-3.17 1.333-5.206 4.083-5.393 3.252-.221 5.771 2.027 5.055 5.369z"
})));
export const ConnectionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Connection",
  xmlns: "http://www.w3.org/2000/svg",
  width: 47,
  height: 39,
  viewBox: "0 0 47 39"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Connection"
}, " Connection"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 0.4
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M3.976 28.29C2.312 28.29 1 29.67 1 31.305v3.68C1 36.67 2.362 38 3.976 38h7.416c1.665 0 2.977-1.38 2.977-3.015v-3.68c0-1.686-1.362-3.015-2.977-3.015H8.77v-4.702h13.672v4.702h-2.624c-1.665 0-2.976 1.38-2.976 3.015v3.68c0 1.686 1.362 3.015 2.976 3.015h7.416c1.665 0 2.977-1.38 2.977-3.015v-3.68c0-1.686-1.362-3.015-2.977-3.015H24.61v-4.702H38.28v4.702h-2.673c-1.665 0-2.977 1.38-2.977 3.015v3.68c0 1.686 1.362 3.015 2.977 3.015h7.416C44.688 38 46 36.62 46 34.985v-3.68c0-1.686-1.362-3.015-2.976-3.015H40.4v-5.826c0-.613-.504-1.073-1.06-1.073H7.66c-.606 0-1.06.51-1.06 1.073v5.775H3.976v.051zm24.064 3.015v3.68c0 .46-.403.869-.857.869h-7.366c-.454 0-.857-.41-.857-.87v-3.679c0-.46.403-.869.857-.869h7.416c.454 0 .807.41.807.87zm15.841 0v3.68c0 .46-.403.869-.857.869h-7.416c-.454 0-.858-.41-.858-.87v-3.679c0-.46.404-.869.858-.869h7.416c.454 0 .857.41.857.87zm-31.631 0v3.68c0 .46-.404.869-.858.869H3.976c-.454 0-.857-.41-.857-.87v-3.679c0-.46.403-.869.857-.869h7.416c.454 0 .858.41.858.87z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M24.606 20.39v-2.832h5.852c2.17 0 3.935-1.789 3.935-3.986V4.986C34.393 2.79 32.627 1 30.458 1H16.635C14.465 1 12.7 2.789 12.7 4.986v8.586c0 2.197 1.766 3.986 3.935 3.986h5.852v2.833h2.119zm-9.737-6.818V4.986c0-1.022.807-1.788 1.766-1.788h13.823c1.009 0 1.766.817 1.766 1.788v8.586a1.766 1.766 0 0 1-1.766 1.788H16.635c-.959 0-1.766-.817-1.766-1.788z"
})));
export const CopyTwoColorIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1605.000000, -595.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(395.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 129.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1210.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "primary-fill",
  id: "Oval",
  cx: 11,
  cy: 11,
  r: 11
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  d: "M14.4782609,7.42857143 L13.6086957,7.42857143 L13.6086957,6.53571429 C13.6086957,6.23228571 13.3824696,6 13.0869565,6 L7.52173913,6 C7.22622609,6 7,6.23228571 7,6.53571429 L7,14.0357143 C7,14.3391429 7.22622609,14.5714286 7.52173913,14.5714286 L8.39130435,14.5714286 L8.39130435,15.4642857 C8.39130435,15.7677143 8.61753043,16 8.91304348,16 L14.4782609,16 C14.7737739,16 15,15.7677143 15,15.4642857 L15,7.96428571 C15,7.66085714 14.7737739,7.42857143 14.4782609,7.42857143 Z M7.52173913,14.2142857 C7.41712,14.2142857 7.34782609,14.1431357 7.34782609,14.0357143 L7.34782609,6.53571429 C7.34782609,6.42829286 7.41712,6.35714286 7.52173913,6.35714286 L13.0869565,6.35714286 C13.1915757,6.35714286 13.2608696,6.42829286 13.2608696,6.53571429 L13.2608696,7.42857143 L8.91304348,7.42857143 C8.61753043,7.42857143 8.39130435,7.66085714 8.39130435,7.96428571 L8.39130435,14.2142857 L7.52173913,14.2142857 Z M14.6521739,15.4642857 C14.6521739,15.5717071 14.58288,15.6428571 14.4782609,15.6428571 L8.91304348,15.6428571 C8.80842435,15.6428571 8.73913043,15.5717071 8.73913043,15.4642857 L8.73913043,7.96428571 C8.73913043,7.85686429 8.80842435,7.78571429 8.91304348,7.78571429 L14.4782609,7.78571429 C14.58288,7.78571429 14.6521739,7.85686429 14.6521739,7.96428571 L14.6521739,15.4642857 Z",
  id: "Shape",
  strokeWidth: 0.2,
  fillRule: "nonzero"
})))))));
export const DemoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Demo",
  width: "50px",
  height: "48px",
  viewBox: "0 0 50 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Demo"
}, " Demo"), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 28,
  transform: "translate(-1318.000000, -678.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(398.000000, 565.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(762.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_demo",
  transform: "translate(158.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M44.65,6.78874614 L29,6.78874614 L27.2,0.688746139 C27.05,0.188746139 26.55,-0.111253861 26,0.0387461388 C25.5,0.188746139 25.2,0.738746139 25.35,1.23874614 L27,6.78874614 L20.5,6.78874614 L22.15,1.23874614 C22.3,0.738746139 22,0.188746139 21.5,0.0387461388 C21,-0.111253861 20.45,0.188746139 20.3,0.688746139 L18.5,6.78874614 L2.85,6.78874614 C1.3,6.78874614 0,8.03874614 0,9.63874614 L0,36.6387461 C0,38.1887461 1.25,39.4387461 2.85,39.4387461 L9,39.4387461 L7,46.2887461 C6.85,46.7887461 7.15,47.3387461 7.65,47.4887461 C7.75,47.5387461 7.85,47.5387461 7.9,47.5387461 C8.3,47.5387461 8.7,47.2887461 8.8,46.8387461 L10.95,39.4387461 L36.55,39.4387461 L38.7,46.8387461 C38.8,47.2387461 39.2,47.5387461 39.6,47.5387461 C39.7,47.5387461 39.8,47.5387461 39.85,47.4887461 C40.35,47.3387461 40.65,46.8387461 40.5,46.2887461 L38.5,39.4387461 L44.65,39.4387461 C46.2,39.4387461 47.5,38.1887461 47.5,36.6387461 L47.5,9.63874614 C47.5,8.03874614 46.25,6.78874614 44.65,6.78874614 Z M45.6,36.5887461 C45.6,37.0887461 45.2,37.5387461 44.65,37.5387461 L2.85,37.5387461 C2.35,37.5387461 1.9,37.1387461 1.9,36.5887461 L1.9,9.58874614 C1.9,9.08874614 2.3,8.63874614 2.85,8.63874614 L19.25,8.63874614 C19.25,8.63874614 19.25,8.63874614 19.25,8.63874614 L19.25,8.63874614 L28.25,8.63874614 C28.25,8.63874614 28.25,8.63874614 28.25,8.63874614 C28.25,8.63874614 28.25,8.63874614 28.25,8.63874614 L44.65,8.63874614 C45.15,8.63874614 45.6,9.03874614 45.6,9.58874614 L45.6,36.5887461 L45.6,36.5887461 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  d: "M29.7477967,23.9592981 L21.8015875,28.9209418 C21.5533035,29.0759713 21.2290287,28.9959955 21.0772996,28.7423109 C21.026748,28.6577907 21,28.5606581 21,28.4616051 L21,18.5383177 C21,18.241013 21.2358822,18 21.5268576,18 C21.6238019,18 21.7188667,18.0273298 21.8015875,18.078981 L29.7477967,23.0406247 C29.9960808,23.1956542 30.074354,23.5269825 29.9226249,23.7806672 C29.8790413,23.853537 29.8191153,23.9147665 29.7477967,23.9592981 Z",
  id: 111,
  stroke: "#3D84FF",
  strokeWidth: 1.9
}))))))));
export const DetailsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Details",
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Details"
}, " Details"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1632.000000, -662.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(395.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1237.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "primary-fill",
  cx: 11,
  cy: 11,
  r: 11
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 7.000000)",
  className: "secondary-stroke secondary-fill",
  fillRule: "nonzero",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.00290698,0.00719767442 C0.63544186,0.00719767442 0.304325581,0.228406977 0.163511628,0.568162791 C0.0231627907,0.907465116 0.100830233,1.2980814 0.360639535,1.55789535 C0.620453488,1.8177093 1.0110814,1.89537209 1.35037209,1.75502326 C1.69012791,1.61422093 1.91132558,1.28309302 1.91132558,0.915627907 C1.91132558,0.674895349 1.81548605,0.443697674 1.64515116,0.273372093 C1.47482558,0.103046512 1.24362791,0.00719767442 1.00289535,0.00719767442 L1.00290698,0.00719767442 Z M1.00290698,1.46069767 C0.782616279,1.46069767 0.583662791,1.32806977 0.499186047,1.12412791 C0.415155814,0.920639535 0.461486047,0.686267442 0.61727907,0.530011628 C0.773534884,0.37422093 1.00790698,0.327883721 1.21139535,0.411918605 C1.41533721,0.496402326 1.54796512,0.695348837 1.54796512,0.915639535 C1.54796512,1.21677907 1.30404651,1.46069767 1.00290698,1.46069767 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.00290698,3.27766279 C0.63544186,3.27766279 0.304325581,3.49887209 0.163511628,3.83862791 C0.0231627907,4.17793023 0.100830233,4.56854651 0.360639535,4.82836047 C0.620453488,5.08817442 1.0110814,5.16583721 1.35037209,5.02548837 C1.69012791,4.88468605 1.91132558,4.55355814 1.91132558,4.18609302 C1.91132558,3.94536047 1.81548605,3.71416279 1.64515116,3.54383721 C1.47482558,3.37351163 1.24362791,3.27766279 1.00289535,3.27766279 L1.00290698,3.27766279 Z M1.00290698,4.73116279 C0.782616279,4.73116279 0.583662791,4.59853488 0.499186047,4.39459302 C0.415155814,4.19110465 0.461486047,3.95673256 0.61727907,3.80047674 C0.773534884,3.64468605 1.00790698,3.59834884 1.21139535,3.68238372 C1.41533721,3.76686744 1.54796512,3.96581395 1.54796512,4.18610465 C1.54796512,4.48724419 1.30404651,4.73116279 1.00290698,4.73116279 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.00290698,6.54789535 C0.63544186,6.54789535 0.304325581,6.76910465 0.163511628,7.10886047 C0.0231627907,7.44816279 0.100830233,7.83877907 0.360639535,8.09859302 C0.620453488,8.35840698 1.0110814,8.43606977 1.35037209,8.29572093 C1.69012791,8.1549186 1.91132558,7.8237907 1.91132558,7.45632558 C1.91132558,7.21559302 1.81548605,6.98439535 1.64515116,6.81406977 C1.47482558,6.64374419 1.24362791,6.54789535 1.00289535,6.54789535 L1.00290698,6.54789535 Z M1.00290698,8.00139535 C0.782616279,8.00139535 0.583662791,7.86876744 0.499186047,7.66482558 C0.415155814,7.46133721 0.461486047,7.22696512 0.61727907,7.0707093 C0.773534884,6.9149186 1.00790698,6.8685814 1.21139535,6.95261628 C1.41533721,7.0371 1.54796512,7.23604651 1.54796512,7.45633721 C1.54796512,7.75747674 1.30404651,8.00139535 1.00290698,8.00139535 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.63813953,1.09744186 L9.72395349,1.09744186 C9.82433488,1.09744186 9.90563953,1.01613721 9.90563953,0.915755814 C9.90563953,0.815374419 9.82433488,0.734069767 9.72395349,0.734069767 L2.63813953,0.734069767 C2.53775814,0.734069767 2.45645349,0.815374419 2.45645349,0.915755814 C2.45645349,1.01613721 2.53775814,1.09744186 2.63813953,1.09744186 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.72383721,4.0044186 L2.63802326,4.0044186 C2.53764186,4.0044186 2.45633721,4.08572326 2.45633721,4.18610465 C2.45633721,4.28648605 2.53764186,4.3677907 2.63802326,4.3677907 L9.72383721,4.3677907 C9.8242186,4.3677907 9.90552326,4.28648605 9.90552326,4.18610465 C9.90552326,4.08572326 9.8242186,4.0044186 9.72383721,4.0044186 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.72383721,7.27465116 L2.63802326,7.27465116 C2.53764186,7.27465116 2.45633721,7.35595581 2.45633721,7.45633721 C2.45633721,7.5567186 2.53764186,7.63802326 2.63802326,7.63802326 L9.72383721,7.63802326 C9.8242186,7.63802326 9.90552326,7.5567186 9.90552326,7.45633721 C9.90552326,7.35595581 9.8242186,7.27465116 9.72383721,7.27465116 Z",
  id: "Path"
}))))))));
export const DocumentIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Document",
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 31,
  viewBox: "0 0 25 31"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Document"
}, " Document"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#434957"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.8 30.828c-.442 0-.8.019-.8-.443V.835C0 .374.358 0 .8 0h15.664a.748.748 0 0 0-.247.049.835.835 0 0 0-.529.786v.837H1.6v27.515h21.496V10.976h.823a.807.807 0 0 0 .777-.64v20.05c0 .46-.335.442-.777.442H.8zM16.585.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.115 11.364c-.458 0-.83-.387-.83-.866V.865c0-.364.219-.69.548-.814a.777.777 0 0 1 .377-.045.818.818 0 0 1 .544.306l7.585 9.509a.881.881 0 0 1 .29.881.837.837 0 0 1-.807.662h-7.707zm5.912-1.596h.257l-5.34-6.508-.278-.359v6.867h5.361z"
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M19.469 16.398H5.032c-.427 0-.774-.31-.774-.691 0-.383.347-.693.774-.693h14.437c.43 0 .776.31.776.693 0 .382-.346.691-.776.691M19.469 19.739H5.032c-.427 0-.774-.31-.774-.692 0-.382.347-.692.774-.692h14.437c.43 0 .776.31.776.692 0 .382-.346.692-.776.692M15.46 22.93H5.045c-.434 0-.788-.309-.788-.692 0-.382.354-.69.788-.69h10.413c.436 0 .79.308.79.69 0 .383-.354.693-.79.693"
})));
export const DocumentationIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Documentation",
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 43,
  viewBox: "0 0 34 43"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Documentation"
}, " Documentation"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#434957"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.831 42.487a.89.89 0 0 1-.89-.89v-5.721h1.78v4.832h18.487v-24.15h-4.272v-1.78h5.162c.49 0 .889.398.889.889v25.93c0 .492-.398.89-.89.89H12.832z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.863 34.683c-.477 0-.863.02-.863-.468V.883C0 .395.386 0 .863 0h16.895a.822.822 0 0 0-.266.052.883.883 0 0 0-.57.83v.884H1.725V32.95h23.186V11.596h.888a.866.866 0 0 0 .838-.675v23.294c0 .488-.361.468-.838.468H.863zM17.889.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.382 12.006a.906.906 0 0 1-.896-.915V.914c0-.385.237-.73.592-.86a.854.854 0 0 1 .407-.047.889.889 0 0 1 .586.322l8.182 10.047a.924.924 0 0 1 .311.93.898.898 0 0 1-.869.7h-8.313zm6.376-1.686h.278l-5.759-6.875-.3-.38V10.32H23.758z"
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M21 17.325H5.428c-.46 0-.835-.327-.835-.73 0-.405.374-.732.835-.732H21c.463 0 .837.327.837.731 0 .404-.374.73-.837.73M21 20.854H5.428c-.46 0-.835-.327-.835-.73 0-.405.374-.732.835-.732H21c.463 0 .837.327.837.731 0 .404-.374.731-.837.731M16.675 24.227H5.442c-.468 0-.85-.327-.85-.732 0-.403.382-.73.85-.73h11.233c.47 0 .85.327.85.73 0 .405-.38.732-.85.732"
})));
export const EfficiencyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Efficiency",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 47 47",
  xmlSpace: "preserve"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Efficiency"
}, " Efficiency"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M23.3 5.7h1v6.5h-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M24.8 12.7h-2V5.2h2v7.5zm-1-1V6.2v5.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M35.4 23.3h6.5v1h-6.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M42.4 24.8h-7.5v-2h7.5v2zm-6.5-1h5.5-5.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M5.7 23.3h6.5v1H5.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M12.7 24.8H5.2v-2h7.5v2zm-6.5-1h5.5-5.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M10.7 11.4l.7-.7 4.6 4.6-.7.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.3 16.7L10 11.4l1.4-1.4 5.3 5.3-1.4 1.4zm-3.9-5.3l3.9 3.9-3.9-3.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  d: "M37 11.4l-.7-.7-9.6 9.6c-1.9-1.5-4.5-1.2-6.1.5s-1.6 4.5 0 6.2c1.7 1.7 4.4 1.8 6.1.2 1.8-1.6 2-4.3.5-6.1l9.8-9.7zM23.8 27.3c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4c.1 1.8-1.5 3.4-3.4 3.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  d: "M23.8 28.8c-1.3 0-2.6-.5-3.5-1.5-1.9-1.9-2-4.9-.2-6.8 1.7-1.9 4.4-2.2 6.4-.8l9.7-9.7 1.4 1.4-9.6 9.7c1.3 2 1 4.8-.8 6.4-1 .9-2.2 1.3-3.4 1.3zm0-8.9c-1.1 0-2.2.5-3 1.3-1.4 1.6-1.3 4 .2 5.5s3.9 1.6 5.5.2c1.6-1.4 1.8-3.8.5-5.4l-.4-.5 9.6-9.6-9.6 9.6-.3-.3c-.8-.6-1.6-.8-2.5-.8zm0 7.9c-2.2 0-3.9-1.8-3.9-3.9s1.8-3.9 3.9-3.9 3.9 1.8 3.9 3.9-1.7 3.9-3.9 3.9zm0-6.9c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9.1-1.6-1.3-2.9-2.9-2.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M23.5 47C10.5 47 0 36.5 0 23.5S10.5 0 23.5 0 47 10.5 47 23.5 36.5 47 23.5 47zm0-45C11.6 2 2 11.6 2 23.5S11.6 45 23.5 45 45 35.4 45 23.5 35.4 2 23.5 2z"
}));
export const EmailVerifyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Email-verify",
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 50,
  viewBox: "0 0 46 50"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Email-verify"
}, " Email verify"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F5F5F5"
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#434957",
  d: "M44.357 17.986l-4.45-3.106V2.504a1.464 1.464 0 0 0-.418-1.078A1.424 1.424 0 0 0 38.425 1h-30.9c-.818 0-1.482.673-1.482 1.503V14.88l-4.4 3.106c-.399.267-.64.718-.643 1.202v28.309C1 48.327 1.664 49 2.483 49h41.034c.819 0 1.483-.673 1.483-1.503V19.188a1.458 1.458 0 0 0-.643-1.202zm-4.45.551l1.484 1.002-1.483 1.804v-2.806zM9.01 4.007h27.933V24.95l-6.724 8.217-6.23-5.812a1.469 1.469 0 0 0-1.977 0l-5.982 5.612-7.02-8.217V4.007zm-2.966 14.53v2.706l-1.434-1.704 1.434-1.002zm-2.077 4.86l9.888 11.624-9.888 9.27V23.396zm2.522 22.597L23 30.512l16.512 15.482H6.488zm35.546-1.704l-9.64-9.068 9.64-11.725V44.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#3D84FF",
  strokeWidth: 1.2,
  d: "M21.256 23L15 16.497l2.784-2.89 3.477 3.61L28.216 10 31 12.891z"
})));
export const ErrorTwoColorIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic-error",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic-error"
}, "Error"), /*#__PURE__*/React.createElement("g", {
  className: "primary-stroke secondary-fill",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.372 16.72L12 13.349 8.628 16.72a.953.953 0 11-1.348-1.348l3.371-3.373L7.28 8.627a.953.953 0 111.348-1.348L12 10.65l3.372-3.371a.953.953 0 111.348 1.348l-3.371 3.372 3.371 3.372a.953.953 0 11-1.348 1.348z"
}));
export const FeatureFlagsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Feature-flags",
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 32,
  viewBox: "0 0 37 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Feature-flags"
}, " Feature flags"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M1.482 5.157h5.334c.376 1.652 1.9 2.892 3.717 2.892 1.818 0 3.34-1.238 3.716-2.892h21.27c.452 0 .82-.357.82-.795a.808.808 0 0 0-.82-.794h-21.27c-.376-1.652-1.9-2.892-3.717-2.892-1.818 0-3.34 1.24-3.716 2.892H1.482a.809.809 0 0 0-.821.794c0 .44.366.795.82.795zm9.051-2.892c1.195 0 2.167.94 2.167 2.097s-.972 2.098-2.167 2.098c-1.194 0-2.166-.94-2.166-2.098 0-1.156.972-2.097 2.166-2.097z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 12.8)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M30.864 3.995h4.656c.453 0 .821-.357.821-.795a.809.809 0 0 0-.82-.795h-4.657a.809.809 0 0 0-.82.795c0 .438.366.795.82.795zM1.231 3.995H23.8c.314 0 .57-.357.57-.795 0-.438-.256-.795-.57-.795H1.231c-.314 0-.57.357-.57.795 0 .438.255.795.57.795z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.478,
  cy: 3.147,
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.8,
  rx: 2.993,
  ry: 2.933
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.4,
  d: "M1.482 28.432h11.31c.376 1.652 1.9 2.894 3.718 2.894s3.34-1.24 3.718-2.894H35.52c.453 0 .821-.356.821-.794a.809.809 0 0 0-.82-.795H20.227c-.376-1.652-1.9-2.892-3.718-2.892s-3.342 1.24-3.718 2.892H1.482a.809.809 0 0 0-.821.795c0 .438.366.794.82.794zm15.028-2.894c1.195 0 2.166.94 2.166 2.098 0 1.156-.971 2.097-2.166 2.097-1.195 0-2.167-.94-2.167-2.097s.972-2.098 2.167-2.098z"
})));
export const FeaturesPricingIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Features-pricing",
  width: "55px",
  height: "53px",
  viewBox: "0 0 55 53",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Features-pricing"
}, " Features pricing"), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 25,
  transform: "translate(-1333.000000, -1043.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(366.000000, 930.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(802.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_features_pricing",
  transform: "translate(165.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 3.000000)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  d: "M23.0283401,34 C23.6518219,34 24.1619433,33.553719 24.1619433,33.0082645 L24.1619433,30.7272727 L24.388664,30.7272727 C27.4493927,30.7272727 30,28.5454545 30,25.8677686 C30,23.1900826 27.5060729,21.0082645 24.388664,21.0082645 L21.6680162,21.0082645 C19.854251,21.0082645 18.3238866,19.7190083 18.3238866,18.1322314 C18.3238866,16.5454545 19.7975709,15.2561983 21.6680162,15.2561983 L27.0526316,15.2561983 C27.6761134,15.2561983 28.1862348,14.8099174 28.1862348,14.2644628 C28.1862348,13.7190083 27.6761134,13.2727273 27.0526316,13.2727273 L24.1052632,13.2727273 L24.1052632,10.9917355 C24.1052632,10.446281 23.5951417,10 22.9716599,10 C22.3481781,10 21.8380567,10.446281 21.8380567,10.9917355 L21.8380567,13.2727273 L21.611336,13.2727273 C18.5506073,13.2727273 16,15.4545455 16,18.1322314 C16,20.8099174 18.4939271,22.9917355 21.611336,22.9917355 L24.3319838,22.9917355 C26.145749,22.9917355 27.6761134,24.2809917 27.6761134,25.8677686 C27.6761134,27.4545455 26.2024291,28.7438017 24.3319838,28.7438017 L18.9473684,28.7438017 C18.3238866,28.7438017 17.8137652,29.1900826 17.8137652,29.7355372 C17.8137652,30.2809917 18.3238866,30.7272727 18.9473684,30.7272727 L21.8947368,30.7272727 L21.8947368,33.0082645 C21.8947368,33.553719 22.4048583,34 23.0283401,34 Z",
  stroke: "#434957",
  strokeWidth: 0.2,
  fill: "#434957"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  d: "M51.0348367,36.1054333 L44.0074224,36.1054333 L41.835856,29.391 C41.7602742,29.1581 41.5436816,29 41.2994509,29 C41.0552202,29 40.8386276,29.1581 40.7630458,29.3915667 L38.5914795,36.106 L31.5640651,36.106 C31.3198344,36.106 31.1032418,36.2641 31.02766,36.4975667 C30.9520782,36.7310333 31.0349926,36.9866 31.2324077,37.1305333 L36.9179633,41.2796667 L34.7463969,47.9952333 C34.6708151,48.2287 34.7537295,48.4842667 34.9511446,48.6282 C35.0498521,48.7007333 35.1666091,48.7364333 35.282802,48.7364333 C35.3989949,48.7364333 35.5157518,48.7007333 35.6144594,48.6282 L41.2994509,44.4785 L46.9838784,48.6282 C47.1824216,48.7732667 47.44865,48.7732667 47.6471932,48.6282 C47.8451724,48.4842667 47.9275227,48.2287 47.8519409,47.9952333 L45.6803745,41.2796667 L51.3659301,37.1305333 C51.5639092,36.9866 51.6462596,36.7310333 51.5706778,36.4975667 C51.495096,36.2641 51.2790674,36.1054333 51.0348367,36.1054333 Z M44.6859663,40.6047667 C44.4879872,40.7492667 44.4056369,41.0048333 44.4812187,41.2383 L46.2427256,46.6862333 L41.6311083,43.3196667 C41.4336932,43.1751667 41.1663367,43.1751667 40.9677935,43.3196667 L36.3556122,46.6862333 L38.1176832,41.2383 C38.193265,41.0048333 38.1103506,40.7492667 37.9129355,40.6053333 L33.3007541,37.2393333 L39.0015389,37.2393333 C39.2457696,37.2393333 39.4623622,37.0812333 39.537944,36.8477667 L41.2994509,31.4004 L43.0609579,36.8472 C43.1365396,37.0806667 43.3531322,37.2387667 43.5973629,37.2387667 L49.2981477,37.2387667 L44.6859663,40.6047667 Z",
  stroke: "#3D84FF",
  strokeWidth: 0.7,
  fill: "#3D84FF"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  d: "M28.5574771,40.1956522 C26.4537131,40.9078675 24.2604273,41.2639752 22.0223805,41.2639752 C10.8769074,41.2639752 1.79043744,32.4057971 1.79043744,21.5445135 C1.79043744,10.6832298 10.8321465,1.7805383 22.0223805,1.7805383 C33.1678535,1.7805383 42.2095626,10.6387164 42.2095626,21.5 C42.2095626,23.1024845 41.9857579,24.7494824 41.6276704,26.3074534 C41.4933876,26.7971014 41.8067141,27.2867495 42.2543235,27.3757764 C42.7466938,27.5093168 43.2390641,27.1977226 43.328586,26.752588 C43.7761953,25.0610766 44,23.2805383 44,21.5 C44,9.65942029 34.1525941,0 22.0223805,0 C9.89216684,0 0,9.65942029 0,21.5 C0,33.3850932 9.89216684,43 22.0223805,43 C24.439471,43 26.8565615,42.5993789 29.1393693,41.8426501 C29.5869786,41.6645963 29.8555443,41.1749482 29.7212614,40.7298137 C29.5422177,40.2846791 29.0050865,40.0621118 28.5574771,40.1956522 Z",
  stroke: "#434957",
  strokeWidth: 0.2,
  fill: "#434957"
}))))))));
export const GetStartedIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Get-started",
  width: "55px",
  height: "53px",
  viewBox: "0 0 55 53",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Get-started"
}, " Get started"), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 25,
  transform: "translate(-532.000000, -1043.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(366.000000, 930.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_get_started",
  transform: "translate(166.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.2088368,5.46324522 C31.0646152,5.46324522 29.9889968,5.91007496 29.1787777,6.72272139 C27.5117695,8.40135204 27.512771,11.1311396 29.1812815,12.8067511 C29.9889968,13.6193975 31.0646152,14.0667305 32.2093376,14.0667305 C33.3530584,14.0667305 34.4286768,13.6193975 35.2373936,12.8072543 C36.9054033,11.1301332 36.9054033,8.40034566 35.2363921,6.72121183 C34.428176,5.91057815 33.3530584,5.46324522 32.2088368,5.46324522 Z M33.8207621,11.3847456 C33.3911157,11.8164798 32.8182537,12.0544871 32.2093376,12.0544871 C31.5999206,12.0544871 31.0280602,11.8164798 30.597913,11.3842425 C29.7095764,10.4920925 29.7090756,9.03888951 30.5954092,8.14623641 C31.0260572,7.71450227 31.5989191,7.4759918 32.2088368,7.4759918 C32.8187545,7.4759918 33.3906149,7.71399908 33.8202614,8.14472685 C34.7080972,9.03838633 34.708598,10.4920925 33.8207621,11.3847456 Z M41.9645153,1.92735268 L41.9329678,1.43724889 C41.9009196,0.933055869 41.5013184,0.530506554 40.9990627,0.497296235 L40.5133318,0.46509229 C40.4262007,0.459054051 39.9534895,0.429869225 39.1963503,0.429869225 C35.6024429,0.429869225 26.6089111,1.06690352 20.7410823,6.96525736 C20.0209988,7.68883975 19.3349666,8.4365751 18.6950037,9.19789649 C17.8978042,8.81044278 16.9744149,8.60262669 16.0139698,8.60262669 C14.2833659,8.60262669 12.6494074,9.24720879 11.5322265,10.3713277 L5.42653984,16.5071857 C4.73550009,17.1990673 4.94481503,18.0348603 5.05748455,18.4837028 C5.07751469,18.5647159 5.09904709,18.6477417 5.1150712,18.7317738 C5.21021435,19.2415019 5.45358052,19.7044336 5.81812903,20.0712567 C6.03745903,20.2916524 6.29684931,20.4697805 6.59780213,20.6056409 L12.0354837,23.0018157 L6.67191364,28.3909446 C6.49464692,28.5690727 6.38998945,28.8075832 6.37947363,29.0591765 C6.37496685,29.1572979 6.30335911,31.4885616 8.62284904,33.8203285 C10.7620677,35.9699419 12.9017872,36.0756111 13.2993854,36.0756111 C13.3329359,36.0756111 13.3544683,36.0746047 13.3619796,36.0746047 C13.6123563,36.0635346 13.8497134,35.9588718 14.0264794,35.7807437 L19.4836904,30.2965125 L22.012996,36.0907067 C22.1376836,36.3840645 22.3164526,36.6492438 22.5462984,36.8822193 C22.9123492,37.2500487 23.3740439,37.4945974 23.8788033,37.5876869 C24.0340369,37.6168718 24.192275,37.6314642 24.3495116,37.6314642 C25.0285332,37.6314642 25.6679954,37.3662848 26.1517232,36.8822193 L32.3210056,30.6814503 C34.1522609,28.8417999 34.5143056,26.035528 33.3155019,23.8124494 C34.0676336,23.1693768 34.7977321,22.4925908 35.4937794,21.792155 C42.7256605,14.5301654 41.9990673,2.435068 41.9645153,1.92735268 Z M12.9358384,34.0301574 C12.3820051,33.9410933 11.2482993,33.6110029 10.0394805,32.3968135 C8.8286587,31.179605 8.50166671,30.0373713 8.41303335,29.4873883 L13.0409966,24.8374406 C13.3584743,26.0128846 13.9228234,27.0318375 14.7240289,27.8389489 C15.4731561,28.5917161 16.4060598,29.1356609 17.4791744,29.4647449 L12.9358384,34.0301574 Z M31.3610612,22.8277131 C30.9344193,23.1739055 30.8648146,23.7993665 31.2033239,24.2326102 C32.383099,25.7421702 32.2559076,27.9023504 30.9058763,29.2584384 L24.7380962,35.4576979 C24.6099034,35.5860105 24.4426517,35.6463929 24.2448541,35.6086539 C24.1386944,35.5890296 24.042049,35.5377046 23.9664352,35.4617234 C23.9173613,35.4119079 23.8798048,35.3570605 23.8517626,35.2901367 L20.8542526,28.4221422 C20.6960145,28.0598478 20.3419818,27.8243565 19.9478888,27.8198278 C18.3304552,27.8012099 17.0495279,27.3287176 16.1416619,26.4164403 C15.2693494,25.5378764 14.8041495,24.3126169 14.7515704,22.778904 C14.7635885,22.6365022 14.7470636,22.4935972 14.6989913,22.3572336 C14.6979898,22.3542145 14.697489,22.3511954 14.6964875,22.3476731 C14.6764574,22.2928257 14.6504182,22.2399911 14.620373,22.1886661 C14.516717,21.9914169 14.3569767,21.8258685 14.145158,21.732779 L7.41102572,18.7654873 C7.34192174,18.7342898 7.28133058,18.6935316 7.23576201,18.6482449 C7.15864598,18.5702509 7.10406386,18.4676008 7.08353297,18.357403 C7.05999756,18.2331159 7.0304531,18.1113447 7.0004079,17.9920895 C6.98688755,17.9372421 6.96986194,17.8718279 6.95784385,17.8149678 L12.9493588,11.7938364 C13.6834633,11.0561648 14.8291872,10.6153733 16.0144706,10.6153733 C16.9013049,10.6153733 17.721539,10.8634443 18.3244462,11.3132931 C18.7560956,11.6358358 19.3655126,11.5568355 19.7030204,11.1351651 C20.4501445,10.1982315 21.2768885,9.27488405 22.1577138,8.38927556 C27.4967469,3.02228681 35.8523188,2.4426158 39.196851,2.4426158 C39.52184,2.4426158 39.7877401,2.44865404 39.985037,2.45519547 C40.06015,4.57059212 40.062153,14.3590819 34.0781494,20.3696464 C33.2183557,21.2346242 32.3044807,22.061863 31.3610612,22.8277131 Z M28.3259946,25.7139917 L23.7451022,30.3171431 C23.3540137,30.7101319 23.3540137,31.3471662 23.7451022,31.740155 C23.9408968,31.9369009 24.1967818,32.0350223 24.4531675,32.0350223 C24.7095533,32.0350223 24.9654383,31.9369009 25.1612329,31.740155 L29.7421254,27.1370035 C30.1332138,26.7440148 30.1332138,26.1069805 29.7421254,25.7139917 C29.3510369,25.3204997 28.7170831,25.3204997 28.3259946,25.7139917 Z M15.3484685,12.6729035 L10.7685775,17.2760549 C10.3774891,17.6690436 10.3774891,18.3060779 10.7685775,18.6995699 C10.9643721,18.8958127 11.2202571,18.9939341 11.4766429,18.9939341 C11.7330287,18.9939341 11.9889137,18.8958127 12.1847083,18.6990667 L16.7645992,14.0959153 C17.1556877,13.7029265 17.1556877,13.0658922 16.7645992,12.6724003 C16.3735108,12.2799147 15.7395569,12.2799147 15.3484685,12.6729035 Z",
  id: "Shape",
  fill: "#434957",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.05448927,36.2386435 C7.44607846,36.6316323 7.44607846,37.2686666 7.05448927,37.6626617 L1.70944705,43.0321664 C1.51365246,43.2284092 1.25776745,43.3265306 1.00138169,43.3265306 C0.74499593,43.3265306 0.489110922,43.2284092 0.293316327,43.0316632 C-0.0977721091,42.6381713 -0.0977721091,42.001137 0.293316327,41.6081482 L5.63835854,36.2386435 C6.02944698,35.8456548 6.66340083,35.8456548 7.05448927,36.2386435 Z M8.97838398,39.0187498 C9.36947242,38.6262642 10.003927,38.625761 10.3950155,39.0192529 C10.7856031,39.4127449 10.7856031,40.0497792 10.3945147,40.442768 L7.816636,43.0321664 C7.62084141,43.2284092 7.3649564,43.3265306 7.10857064,43.3265306 C6.85218488,43.3265306 6.59579912,43.2284092 6.40000452,43.0316632 C6.00941684,42.6381713 6.00941684,42.001137 6.40050528,41.6081482 L8.97838398,39.0187498 Z M2.52918043,35.654947 C2.27329543,35.654947 2.01690967,35.5568256 1.82111507,35.3600797 C1.43002664,34.9670909 1.43002664,34.3300566 1.82111507,33.9370678 L4.1115613,31.6354921 C4.50264974,31.2425034 5.13660359,31.2425034 5.52769203,31.6354921 C5.91878047,32.0284809 5.91878047,32.6655152 5.52769203,33.058504 L3.2372458,35.3600797 C3.0414512,35.5568256 2.7855662,35.654947 2.52918043,35.654947 Z",
  id: "Combined-Shape",
  fill: "#3D84FF"
}))))))));
export const HyperscalerCommissionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Hyperscaler-commission",
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Hyperscaler-commission"
}, " Hyperscaler commission"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M44.65 6.789H29l-1.8-6.1c-.15-.5-.65-.8-1.2-.65-.5.15-.8.7-.65 1.2L27 6.789h-6.5l1.65-5.55a.98.98 0 0 0-.65-1.2.98.98 0 0 0-1.2.65l-1.8 6.1H2.85C1.3 6.789 0 8.039 0 9.639v27c0 1.55 1.25 2.8 2.85 2.8H9l-2 6.85a.98.98 0 0 0 .65 1.2c.1.05.2.05.25.05.4 0 .8-.25.9-.7l2.15-7.4h25.6l2.15 7.4c.1.4.5.7.9.7.1 0 .2 0 .25-.05.5-.15.8-.65.65-1.2l-2-6.85h6.15c1.55 0 2.85-1.25 2.85-2.8v-27c0-1.6-1.25-2.85-2.85-2.85zm.95 29.8c0 .5-.4.95-.95.95H2.85c-.5 0-.95-.4-.95-.95v-27c0-.5.4-.95.95-.95h41.8c.5 0 .95.4.95.95v27z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 1.134,
  d: "M26.6 23.559c-.468-.31-1.219-.632-2.252-.97-1.032-.336-1.764-.695-2.194-1.079-.43-.382-.644-.913-.644-1.594 0-.702.234-1.265.702-1.687.468-.422 1.12-.633 1.955-.633.83 0 1.485.262 1.965.785s.72 1.23.72 2.118h1.05c0-1.126-.284-2.016-.852-2.668-.568-.655-1.37-1.028-2.406-1.117V15h-.9v1.714c-1.013.078-1.814.407-2.402.981-.589.575-.883 1.323-.883 2.245 0 .877.268 1.59.803 2.142.536.551 1.47 1.028 2.799 1.43 1.071.357 1.819.734 2.243 1.133.424.4.635.913.635 1.541 0 .69-.263 1.25-.79 1.682-.526.429-1.208.645-2.044.645-.96 0-1.707-.25-2.242-.751-.536-.501-.804-1.192-.804-2.075H20c0 1.115.323 1.993.971 2.635.647.642 1.563 1 2.746 1.074V31h.892v-1.613c1.054-.078 1.882-.402 2.486-.972.602-.567.905-1.317.905-2.244 0-.59-.117-1.094-.349-1.516-.233-.423-.583-.788-1.051-1.096z"
})));
export const IntegrationInstructionsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Integration-instructions",
  xmlns: "http://www.w3.org/2000/svg",
  width: 43,
  height: 42,
  viewBox: "0 0 43 42"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Integration-instructions"
}, " Integration instructions"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M37.086 33.63a2.385 2.385 0 1 0-3.372 3.375c.45.451 1.05.7 1.686.7.637 0 1.236-.249 1.686-.7.45-.45.698-1.05.698-1.687 0-.638-.248-1.238-.698-1.688zm-1.145 2.23a.782.782 0 0 1-1.082 0 .761.761 0 0 1-.224-.542.762.762 0 0 1 .765-.766.763.763 0 0 1 .765.766.76.76 0 0 1-.224.541z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M26.047 18.467l8.433-8.832 2.21 2.21 5.77-7.975L38.973.38l-7.969 5.775 2.209 2.211L24.78 17.2l-6.957-7.27a8.616 8.616 0 0 0-2.508-6.734 8.631 8.631 0 0 0-9.441-1.878l-1.24.514 4.45 4.453L8.12 8.44l-1.952.795-4.465-4.469-.514 1.241a8.652 8.652 0 0 0 1.876 9.45 8.594 8.594 0 0 0 6.728 2.51l7.22 6.799-4.234 4.355-3.381-3.385-5.949 5.955a5.694 5.694 0 0 0 0 8.037 5.64 5.64 0 0 0 4.015 1.665c1.517 0 3.2-.72 4.272-1.794 1.307-1.206 2.247-2.103 2.822-2.691.69-.706 1.647-1.75 2.87-3.134l-3.381-3.384 4.18-4.266 13.617 13.604a5.639 5.639 0 0 0 4.015 1.665 5.637 5.637 0 0 0 4.015-1.665 5.694 5.694 0 0 0 0-8.037L26.047 18.467zM38.787 2.73l1.325 1.326L36.47 9.09l-2.712-2.715 5.029-3.645zM14.893 33.773l-3.414 3.885c-2.243 1.94-2.977 1.94-4.015 1.94a3.858 3.858 0 0 1-2.748-1.14 3.896 3.896 0 0 1 0-5.5l4.682-4.686 5.495 5.501zm23.714 4.686a3.857 3.857 0 0 1-2.748 1.139 3.86 3.86 0 0 1-2.747-1.14L10.454 16.09l-.433.053a6.829 6.829 0 0 1-5.688-1.956A6.858 6.858 0 0 1 2.44 8.042l3.301 3.304 3.719-1.517 1.764-3.94L7.908 2.57a6.844 6.844 0 0 1 6.139 1.894A6.838 6.838 0 0 1 16 10.156l-.052.434 22.658 22.368a3.897 3.897 0 0 1 0 5.5z"
})));
export const MailingListIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Mailing-list",
  xmlns: "http://www.w3.org/2000/svg",
  width: 83,
  height: 25,
  viewBox: "0 0 83 25"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Mailing-list"
}, " Mailing list"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M44.905 0C43.323 0 42 1.198 42 2.679V22.32C42 23.801 43.323 25 44.905 25h35.19C81.677 25 83 23.802 83 22.321V2.68C83 1.199 81.677 0 80.095 0h-35.19zm.492 1.786h34.206L63.334 15.402c-.405.34-1.263.34-1.668 0L45.396 1.786zm-1.49 1.144l11.904 9.96-11.904 9.236V2.93zm37.186 0v19.196l-11.904-9.235L81.093 2.93zM57.256 14.104l3.143 2.623c1.193.998 3.01.998 4.202 0l3.143-2.623 11.755 9.11H45.5l11.755-9.11z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  x: 14,
  y: 6,
  className: "secondary-fill",
  fill: "#3D84FF",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 2,
  y: 12,
  className: "primary-fill",
  fill: "#434957",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 2,
  x: 24,
  y: 18,
  className: "primary-fill",
  fill: "#434957",
  rx: 1
})));
export const MonthlyDemoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Monthly-demo",
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 47,
  viewBox: "0 0 55 47"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Monthly-demo"
}, " Monthly demo"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.1,
  d: "M34.798 7.506h-6.352L26.743 1.66a.904.904 0 0 0-1.136-.623.94.94 0 0 0-.615 1.15l1.562 5.319h-6.152l1.561-5.319a.94.94 0 0 0-.615-1.15.925.925 0 0 0-1.136.623L18.51 7.506H3.697C2.23 7.506 1 8.704 1 10.237v25.875a2.673 2.673 0 0 0 2.697 2.683h5.82L7.626 45.36a.94.94 0 0 0 .615 1.15c.095.048.19.048.237.048.378 0 .757-.24.852-.67l2.034-7.093h24.229l2.035 7.092c.094.383.473.671.852.671.094 0 .189 0 .236-.048.473-.144.757-.623.615-1.15l-1.892-6.565h5.82c1.467 0 2.697-1.197 2.697-2.683V20.984c-5.271-.176-12.243-1.043-11.157-13.478zm8.46 29.469H3.698a.904.904 0 0 1-.9-.91V10.188c0-.479.379-.91.9-.91H34.184c1.053 0-.36 5.051 2.125 8.319 1.815 2.386 7.847 3.113 7.847 3.736v14.73c0 .48-.378.91-.899.91z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.125 1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.938,
  cy: 10.063,
  stroke: "#434957",
  strokeWidth: 1.71,
  rx: 9.938,
  ry: 10.063
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 0.2,
  d: "M7.151 9.406c.34 0 .634-.102.88-.304.245-.202.368-.492.368-.87 0-.288-.098-.536-.294-.744-.196-.208-.46-.312-.793-.312-.225 0-.411.032-.557.096a.897.897 0 0 0-.347.252 1.91 1.91 0 0 0-.24.405 20.7 20.7 0 0 0-.209.466.392.392 0 0 1-.2.185.778.778 0 0 1-.332.067.572.572 0 0 1-.408-.182.65.65 0 0 1-.186-.486c0-.194.059-.4.175-.615.117-.215.287-.42.51-.614.224-.195.502-.351.835-.47a3.32 3.32 0 0 1 1.115-.176c.358 0 .685.05.981.149.296.099.553.242.77.43a1.853 1.853 0 0 1 .66 1.448c0 .374-.08.695-.24.963-.161.268-.391.529-.69.783.288.157.53.337.728.54.198.201.347.425.447.67.1.245.15.51.15.795a2.507 2.507 0 0 1-.799 1.839 2.837 2.837 0 0 1-.934.584c-.36.14-.76.21-1.195.21a2.83 2.83 0 0 1-1.193-.241A2.745 2.745 0 0 1 4.77 12.92c-.117-.259-.175-.472-.175-.64a.694.694 0 0 1 .726-.725c.104 0 .204.031.3.093a.436.436 0 0 1 .188.222c.193.52.399.906.619 1.16.22.252.53.378.929.378a1.383 1.383 0 0 0 1.19-.68c.138-.224.207-.484.207-.78 0-.438-.118-.781-.355-1.03-.236-.25-.565-.374-.987-.374-.074 0-.188.008-.344.023a4.178 4.178 0 0 1-.3.022c-.203 0-.36-.051-.47-.154a.557.557 0 0 1-.167-.43c0-.18.067-.324.2-.435.133-.11.33-.165.593-.165h.227zm6.276 4.2v-5.11c-.94.73-1.572 1.095-1.897 1.095a.557.557 0 0 1-.413-.188.61.61 0 0 1-.18-.435c0-.191.059-.332.177-.422a3.92 3.92 0 0 1 .627-.348c.447-.213.805-.438 1.073-.674.268-.235.506-.5.713-.791.207-.292.342-.472.404-.54.063-.067.182-.1.355-.1.196 0 .353.076.472.23.118.153.177.365.177.634v6.43c0 .752-.253 1.128-.76 1.128a.693.693 0 0 1-.543-.23c-.137-.153-.205-.38-.205-.68z"
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.805,
  d: "M29.154 23.961l-7.52 4.755a.49.49 0 0 1-.686-.171.53.53 0 0 1-.073-.27v-9.51c0-.284.223-.515.499-.515.091 0 .181.026.26.076l7.52 4.755a.526.526 0 0 1 0 .88z"
})));
export const PartnerIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Partner",
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 43,
  viewBox: "0 0 67 43"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Partner"
}, " Partner"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M66.332 21.106L55.212 1.54a1.311 1.311 0 0 0-1.703-.494l-5.108 2.912a1.328 1.328 0 0 0-.494 1.805l1.022 2.06c-.722.496-1.601.708-2.47.597a15.854 15.854 0 0 1-2.384-.545c-3.746-1.005-9.995-2.708-16.126 0a11.92 11.92 0 0 0-3.218 1.992c-.562 0-1.703-.204-2.878-.375a9.434 9.434 0 0 1-3.219-2.145l.716-1.26a1.328 1.328 0 0 0-.494-1.805L13.747 1.37a1.294 1.294 0 0 0-1.004-.12 1.26 1.26 0 0 0-.8.614L.855 21.447a1.294 1.294 0 0 0-.119 1.004c.084.34.306.63.613.8l5.109 2.913c.197.113.42.172.647.17.119.016.239.016.358 0 .34-.084.63-.306.8-.613l1.209-2.112a38.91 38.91 0 0 0 3.253 3.764l-.273.391a3.406 3.406 0 0 0-.613 1.942 3.406 3.406 0 0 0 1.413 2.758 3.218 3.218 0 0 0 1.942.63h.136a3.406 3.406 0 0 0 0 1.022c.156.88.651 1.662 1.38 2.18a3.27 3.27 0 0 0 1.94.63c.347 0 .691-.05 1.022-.154a3.406 3.406 0 0 0 4.53 2.538c.194.79.666 1.485 1.328 1.958a3.27 3.27 0 0 0 1.941.613h.58a3.304 3.304 0 0 0 2.18-1.362v-.102a15.002 15.002 0 0 0 6.249 1.703 6.675 6.675 0 0 0 2.23-.41 4.87 4.87 0 0 0 2.844-2.315h.562a4.683 4.683 0 0 0 2.674-.817 4.598 4.598 0 0 0 1.805-2.708 4.308 4.308 0 0 0 2.758-1.413 5.756 5.756 0 0 0 1.175-2.078 4.938 4.938 0 0 0 3.406-1.822 3.61 3.61 0 0 0 .494-2.776 3.678 3.678 0 0 0-.443-1.107 11.665 11.665 0 0 0 4.019-3.133l.988 1.703c.174.307.46.533.8.63.119.017.239.017.358 0 .226-.006.447-.064.647-.17l5.108-2.912c.307-.174.533-.461.63-.8a1.294 1.294 0 0 0-.204-.886zm-57.66.34L6.97 24.325l-4.445-2.4L13.287 3.038l4.445 2.537-9.06 15.87zm7.902 9.162a1.703 1.703 0 0 1-2.299.375 1.703 1.703 0 0 1-.392-2.316l.614-.886.783-1.09a1.703 1.703 0 0 1 2.333-.391c.661.485.883 1.372.528 2.111l-1.567 2.197zm3.678 3.525l-.221.307a1.703 1.703 0 1 1-2.708-1.942l.613-.834 1.397-1.958 1.839-2.589a1.703 1.703 0 0 1 2.35-.562 1.6 1.6 0 0 1 .68 1.09c.07.436-.035.882-.289 1.243l-.613.869-3.048 4.376zm4.513 2.35l-.409.562a1.703 1.703 0 1 1-2.673-1.975l3.048-4.292a1.703 1.703 0 0 1 2.946.767 1.55 1.55 0 0 1-.29 1.243l-1.021 1.447-1.601 2.248zm5.721.664l-1.072 1.482-.137.204-.425.579a1.703 1.703 0 0 1-2.844-1.703l.136-.221 1.618-2.265a1.703 1.703 0 0 1 2.299-.358c.737.546.91 1.577.391 2.333l.034-.05zm21.968-7.493a3.644 3.644 0 0 1-2.47 1.107l-10.064-6.3a.851.851 0 0 0-1.29.9.834.834 0 0 0 .388.53l9.808 6.165a3.883 3.883 0 0 1-.8 1.328 2.776 2.776 0 0 1-1.992.868l-8.89-4.972a.858.858 0 0 0-.834 1.498l8.515 4.751a2.81 2.81 0 0 1-1.124 1.703 3.116 3.116 0 0 1-2.503.409h-.103a1.226 1.226 0 0 0-.17-.136l-6.811-3.406a.851.851 0 0 0-.767 1.516L39.87 38.9a3.27 3.27 0 0 1-1.703 1.277 9.962 9.962 0 0 1-6.811-1.209l.545-.834a3.406 3.406 0 0 0 .579-2.52 3.406 3.406 0 0 0-3.167-2.793 3.542 3.542 0 0 0 .102-1.584 3.406 3.406 0 0 0-1.363-2.18 3.406 3.406 0 0 0-2.111-.63c.05-.327.05-.66 0-.987a3.406 3.406 0 0 0-6.08-1.397l-.153.205a3.1 3.1 0 0 0-1.09-1.311 3.406 3.406 0 0 0-4.7.783l-.136.17a40.443 40.443 0 0 1-3.405-3.985L17.8 8.862a9.775 9.775 0 0 0 3.883 2.367l1.703.239a9.979 9.979 0 0 0-1.84 3.882 3.78 3.78 0 0 0 1.005 3.56 3.712 3.712 0 0 0 3.406 1.021 5.739 5.739 0 0 0 3.303-1.992l1.703-2.265 2.401-.63a71.52 71.52 0 0 1 18.408 11.92h.103c.05.059.106.11.17.153.347.255.584.633.664 1.056.12.508.027 1.043-.255 1.481zm.221-4.24a71.52 71.52 0 0 0-18.85-12.073 1.124 1.124 0 0 0-.478 0 1.209 1.209 0 0 0-.34 0l-2.64.698c-.282.08-.532.248-.715.477l-1.703 2.35a4.19 4.19 0 0 1-2.333 1.396 2.043 2.043 0 0 1-1.873-.562 2.146 2.146 0 0 1-.562-1.992 8.157 8.157 0 0 1 2.52-4.274 11.443 11.443 0 0 1 3.083-1.959c5.551-2.435 11.46-.834 14.985.12.873.272 1.767.472 2.673.596a5.228 5.228 0 0 0 3.406-.818l7.186 12.636a9.877 9.877 0 0 1-4.376 3.405h.017zm7.56-1.26l-1.6-2.81-7.51-13.197-1.617-2.844 4.427-2.588 10.728 18.902-4.427 2.537z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M9.13 15.922l.02.012a.977.977 0 0 1 .346 1.354L7.14 21.155a1 1 0 0 1-1.354.346l-.02-.012a.977.977 0 0 1-.346-1.354l2.356-3.867a1 1 0 0 1 1.354-.346zM52.766 6.01l-.003.002a.996.996 0 0 0-.363 1.364l2.566 4.405a1 1 0 0 0 1.364.362l.003-.002a.996.996 0 0 0 .363-1.364L54.13 6.373a1 1 0 0 0-1.364-.363z"
})));
export const PressReleaseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Press-release",
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 43,
  viewBox: "0 0 54 43"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Press-release"
}, " Press release"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  stroke: "#FFF",
  strokeWidth: 0.5,
  d: "M33.146.49l1.23-.216C35.78.026 37.011.851 37.25 2.2l5.02 28.47c.208 1.178-.668 2.375-2.073 2.623l-1.23.216c-1.229.217-2.431-.44-2.815-1.587-4.047-2.413-8.413-3.554-13.304-3.56l5.414 10.162c.559 1.117.472 1.653-.552 2.008l-6.85 1.207c-.497.262-1.464-.089-2.053-1.375L13.07 29.39c-2.283.403-4.04.713-6.093-.662l-1.756.31c-1.405.247-2.637-.578-2.845-1.757L.89 18.858c-.238-1.347.697-2.207 2.102-2.455l1.756-.31c.846-1.365 2.133-2.286 3.538-2.534 9.835-1.734 16.069-3.354 22.728-10.781-.003-1.042.902-2.07 2.132-2.287zm2.501 28.567L31.49 5.473c-6.748 6.922-13.157 8.573-22.817 10.276-1.405.248-2.456 1.475-2.16 3.16l1.159 6.57c.238 1.347 1.675 2.31 3.08 2.062 9.309-1.641 16.54-2.743 24.896 1.516zm2.759 2.292l.175-.03 1.23-.217.176-.031-5.02-28.47c-.03-.168-.206-.137-.206-.137l-1.23.217s-.175.03-.145.2l5.02 28.468zM4.05 18.301s-.732-.045-1.024.354l1.455 8.254c.03.169 1.054-.185 1.054-.185L4.051 18.3zM25.95 38.757l-5.473-10.499c-2.138.203-3.367.42-5.124.73l5.503 10.667 5.094-.898z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M45.027 16.54c-1.239.151-1.49-1.886-.25-2.038l6.996-.86c1.593-.195 1.843 1.842.25 2.038l-6.996.86zM52.021 22.827c1.4.577.324 2.38-.865 1.933l-5.958-1.848c-1.225-.615-.22-2.752 1.04-1.97l5.783 1.885zM43.323 10.048c-1.07 1.053-2.497-.702-1.427-1.58l5.444-4.43c1.07-1.053 2.497.878 1.248 1.58l-5.265 4.43z"
})));
export const PricingIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pricing",
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 38,
  viewBox: "0 0 70 38"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pricing"
}, " Pricing"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.5,
  d: "M34.368 29.428a.87.87 0 0 0 .873-.86v-1.98h.175c2.36 0 4.326-1.893 4.326-4.216 0-2.323-1.923-4.216-4.326-4.216H33.32c-1.398 0-2.578-1.119-2.578-2.496 0-1.376 1.136-2.495 2.578-2.495h4.15a.87.87 0 0 0 .875-.86.87.87 0 0 0-.874-.86h-2.272v-1.98a.87.87 0 0 0-.874-.86.87.87 0 0 0-.874.86v1.98h-.175c-2.359 0-4.325 1.892-4.325 4.215 0 2.324 1.922 4.217 4.325 4.217h2.098c1.398 0 2.577 1.118 2.577 2.495s-1.136 2.495-2.577 2.495h-4.151a.87.87 0 0 0-.874.86c0 .474.393.861.874.861h2.272v1.98c0 .473.393.86.874.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fil",
  fill: "#3D84FF",
  d: "M40.246 29.897l5.67-5.417a.56.56 0 0 1 .787 0l5.669 5.417a.503.503 0 0 1 0 .752l-.61.583a.56.56 0 0 1-.787 0l-3.646-3.483v10.604c0 .292-.257.537-.562.537h-.851c-.306 0-.563-.245-.563-.537V27.672l-3.726 3.56a.56.56 0 0 1-.787 0l-.61-.583a.516.516 0 0 1 .016-.752z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.5,
  d: "M39.48 34.587c-1.73.613-3.533.92-5.373.92-9.164 0-16.635-7.623-16.635-16.969 0-9.345 7.434-17.006 16.635-17.006 9.164 0 16.599 7.622 16.599 16.968 0 1.379-.184 2.796-.479 4.137-.11.421.147.842.515.919a.708.708 0 0 0 .884-.536c.368-1.456.552-2.988.552-4.52C52.178 8.312 44.08 0 34.108 0 24.133 0 16 8.312 16 18.5 16 28.727 24.134 37 34.107 37c1.988 0 3.975-.345 5.852-.996.368-.153.589-.574.478-.957a.792.792 0 0 0-.956-.46z"
})));
export const ProtectionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Protection",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -0.005773232318460941 39.3849983215332 49.03315353393555"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Protection"
}, " Protection"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M19.622 2.023c.613.123 1.229.243 1.84.366 1.464.292 2.93.58 4.4.874l5.341 1.059c1.538.3 3.08.613 4.616.915.74.148 1.491.333 2.237.442h.031c-.253-.329-.5-.662-.757-.991v24.519c0 .333.01.674 0 1.007 0 .107-.016.216-.025.325a.763.763 0 00-.01.1c-.021.2.051-.339.021-.14-.01.082-.025.16-.041.243a9.479 9.479 0 01-.329 1.306 12.86 12.86 0 01-.3.833c-.01.031-.025.062-.037.093-.078.2.058-.1.045-.113a1.868 1.868 0 01-.107.247c-.072.16-.144.319-.222.473a17.647 17.647 0 01-1.238 2.1c-.134.2-.267.387-.411.572-.072.093-.144.185-.216.284 0 0 .175-.222.078-.1a2.27 2.27 0 00-.058.072c-.041.058-.086.107-.127.164-.333.421-.689.829-1.053 1.217a28.964 28.964 0 01-2.734 2.58c-.271.226-.551.446-.829.668a.819.819 0 01-.1.082c.2-.113.1-.082.051-.041-.072.058-.144.107-.216.164-.154.117-.312.23-.469.35-.658.479-1.332.942-2.015 1.377a52.353 52.353 0 01-4.836 2.73c-.915.463-1.846.9-2.78 1.32.261-.037.53-.066.792-.1-.189-.066-.374-.14-.565-.216a23.539 23.539 0 01-.654-.267c-.082-.037-.243-.1.123.051-.031-.016-.066-.025-.1-.041l-.222-.093c-.148-.066-.3-.127-.452-.2a45.638 45.638 0 01-4.934-2.57q-1.5-.9-2.924-1.928-.37-.271-.74-.555c-.14-.107.181.144 0 0-.062-.045-.117-.093-.181-.14-.127-.1-.253-.2-.374-.3q-.725-.592-1.414-1.223a24.687 24.687 0 01-2.6-2.786c-.045-.062-.206-.271-.021-.021a3.87 3.87 0 00-.144-.185c-.093-.123-.185-.253-.278-.374a14.33 14.33 0 01-.539-.8 16.906 16.906 0 01-.942-1.645 5.974 5.974 0 01-.2-.421 3.41 3.41 0 00-.1-.21l-.045-.107c-.014-.035-.086-.2-.016-.041s-.037-.086-.051-.123c-.025-.062-.051-.127-.078-.189a15.342 15.342 0 01-.181-.5 18.165 18.165 0 01-.51-1.861c-.062-.278-.01.236 0 .1a.79.79 0 000-.1V4.78c-.253.329-.5.662-.757.991a348.62 348.62 0 001.88-.371l4.519-.9q2.72-.54 5.444-1.086c1.567-.312 3.141-.627 4.708-.942.765-.154 1.542-.271 2.3-.456a.08.08 0 01.031 0A1.035 1.035 0 0020.87.745a1.056 1.056 0 00-1.264-.72c-.621.123-1.244.247-1.871.374q-2.257.447-4.519.9-2.72.54-5.444 1.086c-1.544.327-3.111.639-4.679.954-.761.154-1.546.261-2.3.456a.08.08 0 01-.031 0A1.042 1.042 0 000 4.791v25.573a5.333 5.333 0 00.2 1.059 14.2 14.2 0 00.592 1.854 20.565 20.565 0 004.482 6.733 33.894 33.894 0 005.958 4.77 45.307 45.307 0 005.318 2.92 32.607 32.607 0 003 1.275c.518.181 1.034-.148 1.5-.366q1.412-.648 2.792-1.361a51.741 51.741 0 004.712-2.759 33.44 33.44 0 006.417-5.389 19.859 19.859 0 003.187-4.609 12.346 12.346 0 001.1-3.238 7.426 7.426 0 00.127-1.264V4.692a1.043 1.043 0 00-.757-.991c-.613-.123-1.229-.243-1.84-.366-1.464-.292-2.93-.58-4.4-.874l-5.341-1.059c-1.538-.3-3.08-.613-4.616-.915C21.692.34 20.946.183 20.2.046h-.031A1.049 1.049 0 0018.9.761a1.044 1.044 0 00.718 1.262z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  d: "M9.408 22.726l6.435 6.435a1.046 1.046 0 001.456 0l1.254-1.254 3.032-3.032 3.649-3.649 3.182-3.177c.509-.511 1.04-1.011 1.537-1.542 0-.01.016-.016.021-.021a1.041 1.041 0 000-1.456 1.05 1.05 0 00-1.456 0l-1.254 1.255-3.032 3.033-3.649 3.649-3.177 3.176c-.514.514-1.053 1.007-1.542 1.542 0 .01-.016.016-.021.021h1.456l-6.435-6.435a1.041 1.041 0 00-1.456 0 1.052 1.052 0 000 1.455z",
  "data-name": "Path"
}));
export const SalesBellIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Notification",
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 34,
  viewBox: "0 0 30 34"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Notification"
}, "Notification"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.339,
  d: "M11.63 29.617c0 1.994 1.625 3.61 3.63 3.61 2.004 0 3.629-1.616 3.629-3.61"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.2,
  d: "M3.427 30.071h23.146c1.31 0 2.254-.774 2.405-1.972.153-1.21-.514-2.048-1.615-3.314-2.693-3.093-2.884-5.218-3.089-10.151-.195-4.701-3.03-7.939-7.386-8.656a2.868 2.868 0 0 0 .756-3.144A2.831 2.831 0 0 0 15 1c-1.173 0-2.225.73-2.644 1.834a2.868 2.868 0 0 0 .756 3.144c-4.355.717-7.19 3.955-7.386 8.656-.205 4.933-.396 7.058-3.089 10.151C1.536 26.051.87 26.89 1.022 28.1c.152 1.198 1.096 1.972 2.405 1.972zM16.375 3.857c0 .766-.615 1.386-1.375 1.386s-1.376-.62-1.376-1.386c.001-.765.617-1.385 1.376-1.386.76 0 1.375.62 1.375 1.386zM7.18 14.695c.227-5.458 4.188-7.402 7.82-7.402 3.632 0 7.593 1.944 7.82 7.402.166 3.989.353 6.432 1.917 8.993H5.263c1.564-2.56 1.751-5.004 1.917-8.993zM3.73 25.752c.176-.202.34-.4.498-.598h21.542c.157.197.322.396.498.598 1.092 1.256 1.33 1.66 1.266 2.161-.073.572-.563.692-.962.692H3.427c-.399 0-.89-.12-.962-.692-.063-.5.174-.905 1.266-2.161z"
})));
export const SalesEnablementIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Sales-enablement",
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 29,
  viewBox: "0 0 32 29"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Sales-enablement"
}, " Sales enablement"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M27.79.276H4.21C1.896.276 0 2.188 0 4.526v14.021c0 2.337 1.895 4.25 4.21 4.25h8.716l-5.894 4.63c-.38.298-.421.808-.169 1.19.169.213.421.34.674.34.168 0 .379-.042.505-.17l7.58-5.948h.715l7.537 5.906c.168.128.337.17.505.17a.876.876 0 0 0 .674-.34c.294-.382.21-.892-.169-1.19l-5.768-4.589h8.673c2.316 0 4.211-1.912 4.211-4.249V4.525C32 2.188 30.105.276 27.79.276zm2.526 18.271c0 1.402-1.137 2.55-2.527 2.55H4.211c-1.39 0-2.527-1.148-2.527-2.55V4.525c0-1.402 1.137-2.55 2.527-2.55h23.578c1.39 0 2.527 1.148 2.527 2.55v14.022z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M26.147 5.12h-6.484a.848.848 0 0 0-.842.85c0 .467.379.85.842.85h4.421L20.337 10.6l-1.474-1.487c-.337-.34-.884-.34-1.179 0l-5.095 5.184-1.684-1.7c-.337-.34-.884-.34-1.179 0l-3.663 3.697a.827.827 0 0 0 0 1.19c.169.17.38.255.59.255.21 0 .42-.085.59-.255l3.073-3.102 1.684 1.7c.337.34.884.34 1.179 0l5.137-5.184 1.473 1.487c.337.34.885.34 1.18 0l4.336-4.419v4.462c0 .467.38.85.842.85a.848.848 0 0 0 .842-.85V5.97a.848.848 0 0 0-.842-.85z"
})));
export const SavingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Savings",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.04627783223986626 -0.000012153107491030823 44.55800247192383 44.5579948425293"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Savings"
}, " Savings"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M22.256 0a22.279 22.279 0 1015.73 6.525A22.258 22.258 0 0022.256 0zm0 42.43a20.2 20.2 0 1114.257-5.916 20.174 20.174 0 01-14.257 5.916z"
}), /*#__PURE__*/React.createElement("text", {
  className: "secondary-fill",
  fontFamily: "OpenSans, Open Sans",
  fontSize: 24,
  transform: "translate(14.256 30.756)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$")), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill secondary-stroke",
  fillRule: "evenodd",
  strokeWidth: 0.25,
  d: "M30.1 34.573l3.135-2.95a.635.635 0 00.049-.808.576.576 0 00-.809.007l-2.2 2.074v-6.311a.554.554 0 10-1.108 0V32.9l-2.2-2.074a.61.61 0 00-.807-.007.627.627 0 00.046.807l3.135 2.95a.537.537 0 00.38.15.619.619 0 00.379-.153z"
}));
export const StyleGuideIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Style-guide",
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 43,
  viewBox: "0 0 45 43"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Style-guide"
}, " Style guide"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.25,
  d: "M36.767 12.423a1.503 1.503 0 0 0-.628-.56V7.517C36.14 3.365 31.777 1 27.63 1s-8.511 2.365-8.511 6.517v26.65a5.464 5.464 0 0 1-5.462 5.466 5.464 5.464 0 0 1-5.463-5.466v-3.24l6.74-12.142c.041-.175.071-.253.088-.335V.683A.683.683 0 0 0 14.34 0H.683A.683.683 0 0 0 0 .683V18.45a.78.78 0 0 0 .048.219l6.78 12.259v3.239A6.83 6.83 0 0 0 13.656 41a6.83 6.83 0 0 0 6.828-6.833V7.517c0-3.397 3.75-5.15 7.145-5.15 3.393 0 7.145 1.753 7.145 5.15v4.346a1.503 1.503 0 0 0-.628.56l-6.098 9.765a.684.684 0 0 0-.068.567l3.148 10.093a.683.683 0 0 0-.451.635v6.834c0 .377.306.683.683.683h8.193a.683.683 0 0 0 .683-.683v-6.834a.683.683 0 0 0-.45-.635l3.181-10.093a.684.684 0 0 0-.068-.567l-6.132-9.765zM11.607 1.367h2.049v16.4h-2.049v-16.4zm-3.414 0h2.049v16.4H8.193v-16.4zm-3.413 0h2.048v16.4H4.78v-16.4zm-3.414 0h2.048v16.4H1.366v-16.4zm.478 17.766h11.334l-3.414 6.15H5.257l-3.413-6.15zm4.171 7.517h2.99l-1.494 2.692-1.496-2.692zM38.87 39.633h-6.827v-5.466h6.827v5.466zm-.505-6.833h-5.817l-3.175-10.154 5.4-8.645v7.622c0 .333 1.203.585 1.366 0v-7.622l5.401 8.645L38.365 32.8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 24.5,
  r: 2.5,
  className: "secondary-stroke",
  stroke: "#3D84FF",
  strokeWidth: 1.5
})));
export const TrainingIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Training",
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 44,
  viewBox: "0 0 70 44"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Training"
}, " Training"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#434957"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 0.3,
  d: "M68.403 14.725l-33-14.547a1 1 0 0 0-.806 0l-33 14.547A1 1 0 0 0 1 15.64v2.219a1 1 0 0 0 .645.935l6.792 2.583v13.406c-1.274.419 3.4.419 2.126 0V22.214l4.25 1.572v5.55h2.124v-6.284c0-2.932 7.226-7.331 18.063-7.331s18.063 4.399 18.063 7.331v6.285h2.124v-5.551l13.168-4.993a1 1 0 0 0 .645-.935V15.64a1 1 0 0 0-.597-.915zm-1.822 2.468l-11.712 4.393c-1.488-4.399-10.094-7.96-19.869-7.96s-18.381 3.561-19.869 7.96l-4.569-1.676v-3.142H8.438v2.304l-5.019-1.88a.453.453 0 0 1-.294-.424c0-.191.113-.364.287-.442L34.594 2.484a1 1 0 0 1 .812 0l31.182 13.842c.174.078.287.251.287.442a.453.453 0 0 1-.294.425z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.95 29h40.1v.696a1 1 0 0 1-1 1h-38.1a1 1 0 0 1-1-1V29z"
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M8.438 34.783a3.055 3.055 0 0 0-2.126 2.933V44h6.375v-6.284c0-1.362-.85-2.514-2.124-2.933H8.437zm2.775 7.849H7.812v-5.128c0-.84.8-1.526 1.7-1.526.9 0 1.7.686 1.7 1.526v5.128z"
})));
export const UserCardIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-User-",
  xmlns: "http://www.w3.org/2000/svg",
  width: 66,
  height: 44,
  viewBox: "0 0 66 44"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User-"
}, " User "), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary primary-fill",
  fill: "#3D84FF",
  d: "M20.362 9.7c-7.068 0-12.819 5.693-12.819 12.69 0 3.089 1.135 6.061 3.193 8.367a12.851 12.851 0 0 0 11 4.25 12.864 12.864 0 0 0 8.26-4.25l.001-.002a12.584 12.584 0 0 0 3.185-8.365c0-6.997-5.75-12.69-12.82-12.69zm0 1.957c5.979 0 10.843 4.814 10.843 10.733 0 2.106-.634 4.145-1.79 5.884a9.885 9.885 0 0 0-5.359-4.205 5.287 5.287 0 0 0 1.694-3.871c0-2.94-2.416-5.331-5.385-5.331-2.97 0-5.386 2.391-5.386 5.33 0 1.526.654 2.9 1.695 3.872a9.883 9.883 0 0 0-5.36 4.207A10.598 10.598 0 0 1 9.52 22.39c0-5.919 4.864-10.733 10.842-10.733zm-.016 11.913c-1.87-.01-3.39-1.518-3.39-3.372 0-1.86 1.53-3.374 3.409-3.374 1.879 0 3.408 1.514 3.408 3.374 0 1.854-1.52 3.361-3.39 3.372h-.037zm-1.107 9.493c-.124-.013-.246-.038-.369-.056-.246-.033-.491-.067-.733-.117-.144-.03-.284-.072-.427-.108-.216-.054-.433-.108-.646-.175-.147-.047-.29-.104-.436-.157a10.878 10.878 0 0 1-.6-.232c-.145-.063-.285-.134-.426-.202-.191-.093-.38-.187-.566-.291-.138-.078-.273-.162-.408-.245-.18-.111-.356-.225-.528-.346-.132-.093-.26-.19-.388-.289a10.796 10.796 0 0 1-.85-.729c-.07-.067-.136-.139-.205-.208 1.347-2.68 4.087-4.381 7.15-4.381h.52l.038.002.038-.002h.522c3.062 0 5.803 1.7 7.15 4.38-.069.07-.134.141-.204.208a10.756 10.756 0 0 1-1.763 1.362c-.138.085-.276.171-.417.25-.183.102-.37.195-.558.287-.144.07-.286.141-.433.204-.196.085-.397.159-.598.232-.146.053-.29.11-.438.157-.213.068-.431.121-.65.176-.14.035-.28.077-.423.107-.243.05-.49.084-.736.118-.123.017-.244.042-.368.055-.372.038-.747.06-1.125.06-.377 0-.752-.022-1.123-.06z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary secondary-fill",
  fill: "#434957",
  d: "M55.574 13.5c.546 0 .989.438.989.979 0 .54-.443.978-.989.978h-1.318a.984.984 0 0 1-.988-.978c0-.54.442-.979.988-.979h1.318zM39.14 15.457a.984.984 0 0 1-.989-.978c0-.54.443-.979.989-.979h10.175c.545 0 .988.438.988.979 0 .54-.443.978-.988.978H39.139zm16.435 3.425c.546 0 .989.438.989.979 0 .54-.443.978-.989.978H39.14a.984.984 0 0 1-.989-.978c0-.54.443-.979.989-.979h16.435zm0 5.382c.546 0 .989.438.989.979 0 .54-.443.978-.989.978h-1.318a.984.984 0 0 1-.988-.978c0-.54.442-.979.988-.979h1.318zM39.14 26.221a.984.984 0 0 1-.989-.978c0-.54.443-.979.989-.979h10.175c.545 0 .988.438.988.979 0 .54-.443.978-.988.978H39.139zm16.435 3.425c.546 0 .989.438.989.979 0 .54-.443.978-.989.978H39.14a.984.984 0 0 1-.989-.978c0-.54.443-.979.989-.979h16.435z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary secondary-stroke",
  stroke: "#434957",
  strokeWidth: 2,
  d: "M2.2 1A1.2 1.2 0 0 0 1 2.2v39.6A1.2 1.2 0 0 0 2.2 43h61.6a1.2 1.2 0 0 0 1.2-1.2V2.2A1.2 1.2 0 0 0 63.8 1H2.2z"
})));
export const UserManageIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Manage-user",
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 41,
  viewBox: "0 0 41 41"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Manage-user"
}, " Manage user"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.9,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-stroke",
  stroke: "#434957"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.616,
  cy: 4.039,
  r: 3.865
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.75 25.942l1.173 11.724c.067.66.621 1.16 1.284 1.16h2.821a1.29 1.29 0 0 0 1.283-1.16l1.17-11.724h2.577l-1.172-11.724a1.29 1.29 0 0 0-1.281-1.16H9.193l-2.577 2.577-2.577-2.577H2.627a1.29 1.29 0 0 0-1.283 1.16L.174 25.942h2.577z"
})), /*#__PURE__*/React.createElement("path", {
  className: "secondary-stroke",
  stroke: "#3D84FF",
  d: "M16.537 11.847c.283-.335.567-.67.876-.98l-2.087-3.633 4.483-2.576 2.087 3.633a9.765 9.765 0 0 1 2.758-.387c.953 0 1.88.13 2.757.387l2.087-3.633 4.484 2.576-2.088 3.634a10.182 10.182 0 0 1 2.732 4.767h4.2v5.153h-4.2a10.182 10.182 0 0 1-2.732 4.767l2.088 3.634-4.484 2.576-2.087-3.633a9.765 9.765 0 0 1-2.757.387 9.765 9.765 0 0 1-2.758-.387l-2.087 3.633-3.375-1.932"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.654,
  cy: 18.212,
  r: 3.865,
  className: "secondary-stroke",
  stroke: "#3D84FF"
})));
export const VideoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Video",
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 31,
  viewBox: "0 0 39 31"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Video"
}, " Video"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F6F6F6",
  strokeWidth: 0.3
}, /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M24.368 14.767a.841.841 0 0 1 0 1.466l-6.873 4.401c-.572.339-1.374-.113-1.374-.79v-8.688c0-.677.802-1.129 1.374-.677l6.873 4.288zm-6.414 3.498l4.238-2.709-4.238-2.708v5.417z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M37.084 1c.572 0 .916.451.916.903v27.194c0 .564-.344.903-.916.903H1.916C1.458 30 1 29.661 1 29.097V1.903C1 1.45 1.458 1 1.916 1h35.168zM7.3 14.654V9.576H2.833v5.078H7.3zm-4.467 1.805v4.965H7.3V16.46H2.833zm6.3 11.736h20.734V2.805H9.133v25.39zm27.034-13.541V9.576H31.7v5.078h4.467zM31.7 16.459v4.965h4.467V16.46H31.7zm4.467-13.654H31.7V7.77h4.467V2.805zm-33.334 0V7.77H7.3V2.805H2.833zm0 25.39H7.3V23.23H2.833v4.965zm33.334 0V23.23H31.7v4.965h4.467z"
})));
export const WarningTwoColorIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "ic_warning",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  className: "primary-stroke secondary-fill"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.01,15.452V9.389a1.231,1.231,0,0,1,2.463,0v6.063a1.231,1.231,0,0,1-2.463,0ZM9.241,6.814a1.48,1.48,0,1,1,1.047-.433,1.48,1.48,0,0,1-1.047.433Z",
  transform: "translate(21.221 22.084) rotate(180)",
  className: "primary-fill"
}));
export const WebinarIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Webinar",
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 34,
  viewBox: "0 0 40 34"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Webinar"
}, " Webinar"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.2,
  d: "M37.19 1H2.81C1.814 1 1 1.829 1 2.841v24.21c0 1.013.814 1.842 1.81 1.842h13.119v2.726h-3.393a.685.685 0 0 0-.679.69c0 .382.304.691.679.691h14.957c.375 0 .678-.31.678-.69a.685.685 0 0 0-.678-.691H24.07v-2.726h13.12c.995 0 1.809-.83 1.809-1.842V2.841C39 1.83 38.186 1 37.19 1zM2.81 2.381h34.38c.246 0 .453.21.453.46v19.632H2.357V2.84c0-.25.207-.46.453-.46zm19.904 29.238h-5.428v-2.726h5.428v2.726zm14.476-4.107H2.81a.462.462 0 0 1-.453-.46v-3.198h35.286v3.197c0 .25-.207.46-.453.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#3D84FF",
  d: "M13.677 20h12.646a.677.677 0 0 0 .479-.201.697.697 0 0 0 .198-.487 7.103 7.103 0 0 0-4.512-6.638 4.267 4.267 0 0 0 1.702-3.418C24.19 6.906 22.315 5 20 5c-2.315 0-4.19 1.905-4.19 4.256 0 1.402.671 2.643 1.703 3.418A7.102 7.102 0 0 0 13 19.312c0 .181.072.359.198.487s.3.201.479.201zm4.318-12.78a2.803 2.803 0 0 1 4.01 0c.514.522.83 1.238.83 2.036 0 .797-.316 1.512-.83 2.036a2.804 2.804 0 0 1-4.01 0 2.893 2.893 0 0 1-.83-2.036c0-.798.316-1.514.83-2.037zm-1.988 8.039a5.581 5.581 0 0 1 7.985 0 5.75 5.75 0 0 1 1.609 3.365H14.399a5.749 5.749 0 0 1 1.608-3.365z"
})));